// React is imported for the JSX below (it was missing, which breaks the
// classic JSX runtime used by jest).
import React, { useCallback } from 'react';

import { useToast, Box, Stack } from '@chakra-ui/react';

import { defaultConfig } from './utils';

export function useToasts() {
  const toast = useToast();

  const errorToast = useCallback(
    ({ title, description = '' }) => {
      toast({
        render: () => (
          <Stack bg="white">
            <Box>{title}</Box>
            <Box>{description}</Box>
          </Stack>
        ),
        //status: 'error',
        ...defaultConfig,
      });
    },
    [toast],
  );

  const successToast = useCallback(
    ({ title, description = '' }) => {
      toast({
        title,
        description,
        status: 'success',
        ...defaultConfig,
      });
    },
    [toast],
  );

  return { errorToast, successToast };
}
